import React from 'react';
import { arrayOf, number } from 'prop-types';
import Skeleton from 'react-loading-skeleton';

import css from './SelectableOptionCardsSkeleton.module.css';

const BADGE_WIDTHS = [88, 110, 130, 72];

const SelectableOptionCardsSkeleton = ({ cardCount, badgeCounts }) => (
  <div className={css.root} aria-busy="true" aria-live="polite">
    {Array.from({ length: cardCount }).map((_, index) => (
      <div key={index} className={css.card}>
        <Skeleton circle width={20} height={20} />
        <div className={css.cardBody}>
          <Skeleton height={18} width="75%" borderRadius={4} />
          <Skeleton height={14} width="55%" borderRadius={4} />
          {badgeCounts[index] > 0 ? (
            <div className={css.badges}>
              {Array.from({ length: badgeCounts[index] }).map((__, badgeIndex) => (
                <Skeleton
                  key={badgeIndex}
                  height={22}
                  width={BADGE_WIDTHS[badgeIndex % BADGE_WIDTHS.length]}
                  borderRadius={999}
                />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    ))}
  </div>
);

SelectableOptionCardsSkeleton.propTypes = {
  cardCount: number,
  badgeCounts: arrayOf(number),
};

SelectableOptionCardsSkeleton.defaultProps = {
  cardCount: 2,
  badgeCounts: [0, 0],
};

export default SelectableOptionCardsSkeleton;
